"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = void 0;
const label = '%cTimer%cAgent';
const bgColorMaps = {
    error: '#df4449',
    warn: '#beab28',
    info: '#277fdf',
    success: '#2dbe5f',
    debug: '#b9a9b5',
};
const labelStyleA = [
    'background: #08272E',
    'color: #F49131',
    'padding: 2px 0 2px 4px',
    'border-top-left-radius: 3px',
    'border-bottom-left-radius: 3px',
];
const labelStyleB = [
    'background: #08272E',
    'color: #20859D',
    'padding: 2px 2px 2px 0',
    'border-top-right-radius: 3px',
    'border-bottom-right-radius: 3px',
];
class LoggerFactory {
    constructor() {
        return new Proxy(this, {
            get: LoggerFactory.__get,
        });
    }
    static __get(target, prop) {
        const allowedMethods = Object.keys(bgColorMaps);
        const normalizedProp = prop === 'log' ? 'debug' : prop;
        if (allowedMethods.includes(normalizedProp)) {
            return (...args) => target.log(normalizedProp, ...args);
        }
        if (Reflect.has(target, normalizedProp)) {
            return Reflect.get(target, normalizedProp);
        }
        return undefined;
    }
    static getStyling(tag = 'debug') {
        const bgColor = bgColorMaps[tag] || bgColorMaps.debug;
        return [
            labelStyleA.join(';'),
            labelStyleB.join(';'),
            `color: ${bgColor};margin-left: 7px`,
        ];
    }
    log(tag = 'debug', ...args) {
        const getFormattingArgs = LoggerFactory.getStyling(tag);
        const loggerMaps = {
            error: console.error,
            warn: console.warn,
            info: console.info,
            success: console.log,
            debug: console.log,
        };
        const logger = loggerMaps[tag] || loggerMaps.success;
        const textArgs = [];
        const objArgs = [];
        args.forEach(arg => {
            if (typeof arg === 'string') {
                textArgs.push(arg);
            }
            else {
                objArgs.push(arg);
            }
        });
        if (textArgs.length) {
            logger.apply(this, [
                `${label}%c${textArgs.join(' ')}`,
                ...getFormattingArgs,
            ]);
        }
        logger.apply(this, objArgs);
    }
}
exports.Logger = new LoggerFactory();
exports.default = {
    install(vm) {
        Object.assign(vm.prototype, {
            $log: exports.Logger,
        });
        vm.directive('log', {
            inserted(el, { value }) {
                exports.Logger.log(value);
            },
        });
    },
};
//# sourceMappingURL=logger.js.map